import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';

interface PagenationProps {
  listAllLength: number | undefined;
  listLimit: number | undefined;
  onCurrentPageChange: (value: number) => void;
  miniSize?: boolean;
}

const Pagenation = ({
  listAllLength,
  listLimit,
  onCurrentPageChange,
  miniSize = false,
}: PagenationProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(Number(listAllLength) / Number(listLimit));

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
    onCurrentPageChange(pageNumber);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [listLimit, listAllLength]);

  const startPage = Math.floor((currentPage - 1) / 10) * 10 + 1; // 현재 페이지를 기준으로 시작 페이지
  const endPage = Math.min(startPage + 9, totalPages); // 10 페이지까지 표시하지만 totalPages를 넘지 않도록

  return (
    <>
      <Box className="flex jcc aic" $miniSize={miniSize}>
        <div className="flex">
          <button
            className="arrow-btn img-box"
            type="button"
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          >
            <img src="/img/arrow_prev_double_222.svg" />
          </button>
          <button
            className="arrow-btn img-box"
            type="button"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <img src="/img/arrow_prev_222.svg" />
          </button>
        </div>
        {/* <NumBox $miniSize={miniSize}>
          {[...Array(totalPages)].map((_, pageIndex) => (
            <li
              key={pageIndex}
              className={currentPage === pageIndex + 1 ? 'active' : ''}
              onClick={() => handlePageChange(pageIndex + 1)}
            >
              {pageIndex + 1}
            </li>
          ))}
        </NumBox> */}
        <NumBox $miniSize={miniSize}>
          {[...Array(endPage - startPage + 1)].map((_, index) => {
            const pageNumber = startPage + index;
            return (
              <li
                key={pageNumber}
                className={currentPage === pageNumber ? 'active' : ''}
                onClick={() => handlePageChange(pageNumber)}
              >
                {pageNumber}
              </li>
            );
          })}
        </NumBox>
        <div className="flex">
          <button
            className="arrow-btn img-box"
            type="button"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            <img src="/img/arrow_next_222.svg" />
          </button>
          <button
            className="arrow-btn img-box"
            type="button"
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
          >
            <img src="/img/arrow_next_double_222.svg" />
          </button>
        </div>
      </Box>
    </>
  );
};

export default Pagenation;

export const Box = styled.div<{ $miniSize?: boolean }>`
  gap: ${(props) => (props.$miniSize ? '4px' : '16px')};
  .arrow-btn {
    width: ${(props) => (props.$miniSize ? '20px' : '32px')};
  }
`;

export const NumBox = styled.ul<{ $miniSize?: boolean }>`
  display: flex;
  gap: ${(props) => (props.$miniSize ? '4px' : '8px')};
  > li {
    width: ${(props) => (props.$miniSize ? '16px' : '24px')};
    height: ${(props) => (props.$miniSize ? '16px' : '24px')};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${(props) => (props.$miniSize ? '3px' : '4px')};
    background: #d7d7d7;
    color: #fff;
    font-size: ${(props) => (props.$miniSize ? '10px' : '13px')};
    cursor: pointer;
    &.active {
      background: ${(props) => props.theme.mainColor1};
    }
  }
`;
